class Utils {
  static formatPriceEUR(price) {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 0,
    }).format(price);
  }

  static getEnv() {
    let ENDPOINT;
    const { href } = window.location;
    if (
      href.includes('dev.') ||
      href.includes('localhost') ||
      href.includes('tagenergy.')
    ) {
      ENDPOINT = process.env.REACT_APP_API_URL_DEV;
    } else if (window.location.href.includes('staging.')) {
      ENDPOINT = process.env.REACT_APP_API_URL_STAGING;
    } else {
      ENDPOINT = process.env.REACT_APP_API_URL;
    }

    const HELLIO_EDPOINT = process.env.REACT_APP_HELLIO_API_URL;

    const cryptoKEY = process.env.REACT_APP_API_CRYPTO_KEY;
    const token = process.env.REACT_APP_API_TOKEN;
    const tokenHellio = process.env.REACT_APP_HELLIO_API_TOKEN;

    return {
      ENDPOINT,
      HELLIO_EDPOINT,
      cryptoKEY,
      token,
      tokenHellio,
    };
  }
}

export default Utils;
